import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

const useAuth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokenExpiration = () => {
      const token = localStorage.getItem("token");
      if (!token) {
        localStorage.clear();
        navigate("/sign-in");
        return false;
      }

      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
          localStorage.clear();
          navigate("/sign-in");
          return false;
        }

        localStorage.setItem("is_admin", decodedToken.role_id === 3 ? "true" : "false");
        return true;
      } catch (err) {
        console.error("Error decoding token", err);
        localStorage.clear();
        navigate("/sign-in");
        return false;
      }
    };

    // Check immediately and set up interval
    const isValid = checkTokenExpiration();
    if (!isValid) return;

    const interval = setInterval(checkTokenExpiration, 60000); // Check every minute
    return () => clearInterval(interval);
  }, [navigate]);
};

export default useAuth;